module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/saledeed/soldproperty/soldproperty.component.css
// module id = ./src/app/allocation/saledeed/soldproperty/soldproperty.component.css
// module chunks = main